import React, {Component} from "react";
import {Card, CardBody, Progress,Col,Row} from "reactstrap";



class Error extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12" lg="12">
                        <Card className={`text-white bg-${this.props.type} text-center`}>
                            <CardBody className="card-body">
                                <blockquote className="card-bodyquote">
                                        <i className="fa fa-exclamation-triangle fa-lg mt-4 pb-3"></i><br/>
                                        <p>{this.props.message}</p>
                                </blockquote>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}



export default Error;


// WEBPACK FOOTER //
// ./src/views/site/DeviceMessages/Error.js